<template>
    <div class="main-container">
     <breadcrumb
        main_step_name="Payroll"
        sub_step_name="Reports"
        step_name="Report Module"
       @goToSubStep="routeToSubStep"/>
       <br><br>
       <tl-header type="h3" class="head">
          Custom Report Builder
      </tl-header>
      <txt label="Report Name"/>
      <div class="type">
          <tl-select
            label="Financial Year"
            :options="['2019-2020','2018-2019','2017-2018','2016-2017','2015-2016']"
            @change="(val)=>finyear=val"/>
          <tl-select
            label="Month"
            :options="['January','February','March','June','July','August','September','October','November','December']"
            @change="(val)=>month=val"/>
      </div>
      <span class="label">Select Employee</span>
      <br><br>
      <div class="filters">
        <tl-select
            label="PayGroup"
            :options="paygroupList"
            />
        <tl-select
            label="Employee Type"
            :options="['Resigned','Active','Contract']"
         />
        <tl-select
            label="Criteria"
            :options="criteria"
            @change="onSelectCriteria($event)"
         />
        <tl-select
             v-if="this.criteriaName"
            :label="criteriaName"
            :options="dropdownList"
         />
       </div>
       <btn class="btnfilter" text="Apply filters" type="secondary"/>
    </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data(){
    return{
      criteria: [
        "Department",
        "Location",
        "Cost Centre",
        "Salary Band",
        "Salary Grade",
        "Designation"
      ],
      paygroupList:[],
      criteriaName:'',
      dropdownList:[]
    }
  },
  mounted(){
    this.fetchPayGroup()
  },
  computed:{
    le_id() {
      return "d23da995-2dc4-4abf-bbaa-fcab5fcd696c";
    }
  },
  methods:{
   ...mapActions({
      fetch_location: "onboard/locations/fetchAll",
      fetch_pay_group: "dashboard/payroll/monthlypayroll/payGroup/fetchAll",
      fetch_salary_grades: "onboard/salary_grades/fetchAll",
      fetch_salary_bands: "onboard/salary_bands/fetchAll",
      fetch_departments: "onboard/departments/fetchAll",
      fetch_designations: "onboard/designations/fetchAll",
      fetch_cost_centre: "onboard/cost_centres/fetchAll",
      fetch_legal_entities: "onboard/legal_entities/fetchAll"
   }),
   routeToSubStep(){
      this.$router.push(`/dashboard/${this.$route.params.entity_index}/reports/reportsDashboard/reportModule`)
    },
   async fetchPayGroup() {
      try {
        //console.log("leId", this.le_id);

        let res = await this.fetch_pay_group(this.le_id);
        res.data.data.forEach(element => {
          this.paygroupList.push(element.name);
        });
        //console.log(this.paygroupList);
      } catch (err) {
        //console.log(err);
      }
    },
    onSelectCriteria(event) {
      this.criteriaName = event;
    //   //console.log('criteria', this.criteriaName)
      switch (this.criteriaName) {
        case "Location":
          this.fetchLocations();
          break;
        case "Department":
          this.fetchDepartments();
          break;
        case "Cost Centre":
          this.fetchCostCentres();
          break;
        case "Salary Band":
          this.fetchSalaryBands();
          break;
        case "Salary Grade":
          this.fetchSalaryGrades();
          break;
        case "Designation":
          this.fetchDesignations();
          break;
        default:
          //console.log("none");
          break;
      }
    },
    async fetchCostCentres() {
      try {
        //console.log("leId", this.le_id);

        let res = await this.fetch_cost_centre(this.le_id);
        if (!res.data.rows.length) {
          res.data.rows.forEach(element => {
            this.dropdownList.push(element.name);
          });
        }

        //console.log(res.data);
      } catch (err) {
        //console.log(err);
      }
    },
    async fetchLocations() {
      try {
        //console.log("leId", this.le_id);

        let res = await this.fetch_location(this.le_id);
        this.dropdownList = res.data;
        //console.log(this.dropdownList);
      } catch (err) {
        //console.log(err);
      }
    },
    async fetchSalaryBands() {
      try {
        //console.log("leId", this.le_id);

        let res = await this.fetch_salary_bands(this.le_id);
        if (!res.data.rows.length) {
          res.data.rows.forEach(element => {
            this.dropdownList.push(element.name);
          });
        }

        //console.log(res.data);
      } catch (err) {
        //console.log(err);
      }
    },
    async fetchSalaryGrades() {
      try {
        //console.log("leId", this.le_id);

        let res = await this.fetch_salary_grades(this.le_id);
        if (!res.data.rows.length) {
          res.data.rows.forEach(element => {
            this.dropdownList.push(element.name);
          });
        }
        //console.log(res.data);
      } catch (err) {
        //console.log(err);
      }
    },
    async fetchDesignations() {
      try {
        //console.log("leId", this.le_id);

        let res = await this.fetch_designations(this.le_id);
        if (!res.data.rows.length) {
          res.data.rows.forEach(element => {
            this.dropdownList.push(element.name);
          });
        }

        //console.log(res.data);
      } catch (err) {
        //console.log(err);
      }
    },
  }
}
</script>

<style lang="scss" scoped>
.type{
   display: flex;
   margin-top: 30px;
   div{
     width: 250px;
     padding-right: 20px;
   }
}
</style>
